import PropTypes from 'prop-types';
import { Typography } from '@leegality/leegality-react-component-library';
import { HelpTooltip } from '@components/help-tooltip';
import { getTranslation } from '@utils';

const ChannelHeader = ({ heading, helpText, compact }) => {
  const showHelpIcon = !!(helpText && helpText.trim());

  return (
    <div className={`flex items-start gap-1 ${compact ? '' : 'pb-2'}`}>
      <Typography
        tag={Typography.Tags.P}
        variant={Typography.Variants.sm}
        fontWeight={Typography.FontWeight.medium}
        className="text-gray-500 break-words min-w-0"
      >
        {heading || getTranslation('COMMUNICATION_CHANNELS_LABEL')}
      </Typography>
      {showHelpIcon && <HelpTooltip text={helpText} />}
    </div>
  );
};

ChannelHeader.propTypes = {
  heading: PropTypes.string,
  helpText: PropTypes.string,
  compact: PropTypes.bool,
};

ChannelHeader.defaultProps = {
  heading: '',
  helpText: '',
  compact: false,
};

export default ChannelHeader;
